export default {
  onboarding: {
    title: "Il s'agit d'un SAFE Tag!",
    description: 'Vous pouvez lier votre SAFE Tag et commencer à être protégé par SOSAFE.',
  },
  linkSafetag: 'Lien SAFE Tag',
  disclaimerSosafe: 'Téléchargez la dernière version de SOSAFE pour lier votre SAFE Tag',
};
